import React, {useState} from 'react'
import {useParams, useLocation, useNavigate} from 'react-router-dom'
import {BsArrowLeft} from "react-icons/bs";
import AccessoriesInnerSpecificationLayout from "./AccessoriesInnerSpecificationLayout";
import AccessoriesDependLimitLayout from "./AccessoriesDependLimitLayout";
import AccessoriesDependSpecificationParameter from "./AccessoriesDependSpecificationParameter";
import AccessoriesInnerSpecificationParameter from "./AccessoriesInnerSpecificationParameter";


const AccessoriesDependLayout = () => {
    const {rowId} = useParams();
    const [specificationRowId, setSpecificationRowId] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <div className="px-4 pt-4 mb-2 sm:px-6 lg:px-8">
                <div className="flex items-center">
                    <button
                        className="mr-3 duration-300 ease-in-out hover:text-blue-900 hover:-translate-x-3"
                        onClick={() => navigate(-1)}
                    >
                        <BsArrowLeft className="w-6 h-6 mr-1 hover:cursor-pointer"/>
                    </button>
                    <h3 className="text-2xl">
                        {location.state.item.article+ " - " +location.state.item.supplierName+ " - " +location.state.item.productName}
                    </h3>
                </div>
                <div className='grid grid-cols-6 mt-4 gap-x-5'>

                    {/*FURNITURE DEPEND SPECIFICATION LIMIT TABLE*/}
                    <div className="col-span-6">
                        <AccessoriesDependLimitLayout
                            dependSpecificationId={rowId}
                        />
                    </div>

                    {/*FURNITURE DEPEND SPECIFICATION TABLE*/}
                    <div className="col-span-6 sm:col-span-3">
                        <AccessoriesInnerSpecificationLayout
                            setSpecificationRowId={setSpecificationRowId}
                            dependSpecificationId={rowId}
                        />
                    </div>

                    {/*FURNITURE DEPEND SPECIFICATION TABLE*/}
                    <div className="col-span-6 sm:col-span-3">
                        <AccessoriesInnerSpecificationParameter
                            innerSpecificationId={specificationRowId}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccessoriesDependLayout;
